import { render, staticRenderFns } from "./Ctablafinanciera2.vue?vue&type=template&id=1d80565a&"
import script from "./Ctablafinanciera2.vue?vue&type=script&lang=js&"
export * from "./Ctablafinanciera2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports